import { BACKGROUND_HEIGHT, BACKGROUND_WIDTH } from '@config';

export const calcScale = () => {
  const horizontalScale =  document.documentElement.clientWidth / BACKGROUND_WIDTH;
  const verticalScale =  document.documentElement.clientHeight / BACKGROUND_HEIGHT;
  return (verticalScale > horizontalScale) ? verticalScale : horizontalScale;
};